import type Decimal from "decimal.js";

export type Serialized<T> = T extends Date
  ? string
  : T extends Decimal
    ? string
    : T extends (infer U)[]
      ? Serialized<U>[]
      : T extends object
        ? { [K in keyof T]: Serialized<T[K]> }
        : T;
